// extracted by mini-css-extract-plugin
export default {"lds-spinner":"style_lds-spinner__m1pSE","div-after":"style_div-after__cuClF"};